module.exports = __webpack_public_path__ + "static/img/Frame 22.61e72ad1.png";